/**
 * Small components shared by the Sales Rep Performance page and its Janus
 * pictures: the chart frame and the KPI tile.
 */

import { lazy, Suspense } from 'react'

import type { EChartsOption } from 'echarts'

import { tone } from './format'

const Chart = lazy(() => import('../../components/Chart'))

export function ChartFrame({ option, label, height }: { option: EChartsOption; label: string; height: number }) {
  return (
    <Suspense fallback={<div className="state">Loading chart…</div>}>
      <Chart option={option} ariaLabel={label} height={height} />
    </Suspense>
  )
}

export function Kpi({
  label,
  value,
  sub,
  toneValue,
}: {
  label: string
  value: string
  // `| undefined`: `exactOptionalPropertyTypes` is on, and callers pass undefined.
  sub?: string | undefined
  toneValue?: number | undefined
}) {
  return (
    <article className="srp-kpi">
      <p className="srp-kpi-label">{label}</p>
      <p className={`srp-kpi-value cell-number ${toneValue === undefined ? '' : tone(toneValue)}`}>
        {value}
      </p>
      {sub !== undefined && <p className="srp-kpi-sub">{sub}</p>}
    </article>
  )
}
